import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { getModuleViewComponents } from './constantRoutes.js'
import { isProd } from '@/support/helper.js'
import guard from './guard/index.js'
import { tv } from '@/i18n/viewText.js'

// const userStore = useUserStore()
getModuleViewComponents()
const notInProdRoute = () => {
  if (isProd()) {
    return [] as RouteRecordRaw[]
  } else {
    return []
  }
}
// @ts-ignore
// .concat(moduleRoutes)
export const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    meta: { title: 'Dashboard', icon: 'home', hidden: false },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        meta: { title: '工作台', icon: 'home', hidden: false, keepalive: 1 },
        component: () => import('@/views/dashboard/index.vue')
      }
    ]
  },
  {
    path: '/bi',
    name: 'Biview',
    component: () => import('@/views/biview/index.vue'),
    meta: {
      title: tv('BI驾驶舱'),
      icon: 'view',
      is_blank: 2
    }
  },
  {
    path: '/biview',
    name: 'BiviewSecond',
    component: () => import('@/views/biviewSecond/index.vue'),
    meta: {
      title: 'BI视图',
      icon: 'view'
    }
  }

  // @ts-ignore
].concat(notInProdRoute() as any)
// default routes, it will not change to menus
export const defaultRoutes: RouteRecordRaw[] = [
  // 菜单不需要加入用户管理
  {
    path: '/users',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '用户管理',
      hidden: true
    },
    children: [
      {
        path: '/users/center',
        name: 'user-center',
        meta: { title: '个人中心', hidden: '1' },
        component: () => import('@/views/user/center.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: () => import('@/views/login/index.vue')
  }
  // {
  // 	path: "/develop",
  // 	meta: { title: "开发者工具" },
  // 	component: () => import("@/layout/index.vue"),
  // 	children: [
  // 		{
  // 			path: "/develop/modules",
  // 			name: "develop-modules",
  // 			meta: { title: "模块管理" },
  // 			component: () => import("@/views/develop/module/index.vue")
  // 		}
  // 		// {
  // 		// 	path: "/develop/schema",
  // 		// 	name: "develop-schema",
  // 		// 	meta: { title: "Schema" },
  // 		// 	component: () => import("@/views/develop/schema/index.vue")
  // 		// },
  // 		// {
  // 		// 	path: "/develop/generate",
  // 		// 	name: "develop-generate",
  // 		// 	meta: { title: "列表管理" },
  // 		// 	component: () => import("@/views/develop/generate/index.vue")
  // 		// },
  // 		// {
  // 		// 	path: "/develop/generator",
  // 		// 	name: "develop-generator",
  // 		// 	meta: { title: "数据表管理" },
  // 		// 	component: () => import("@/views/develop/generator/index.vue")
  // 		// }
  // 	]
  // },
]

const routes = constantRoutes.concat(defaultRoutes)
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  // 路由滚动
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0, behavior: 'smooth' }
  }
})

// 挂载路由之前
// 先绕开路由守卫用于开发
guard(router)

export default router
